export default function(parameters) {
    Object.keys(parameters).forEach(key => {
        if (parameters[key] === null) {
            parameters[key] = 'no_value';
        }
    });
    return parameters;
}
